var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61538 1.7H10.4615C10.9671 1.7 11.3769 2.10983 11.3769 2.61538V3.92308H1.7V2.61538C1.7 2.10983 2.10983 1.7 2.61538 1.7ZM13.0769 3.92308C14.5214 3.92308 15.6923 5.09402 15.6923 6.53846V7.84615H16.2736C16.6748 7.84615 17.0001 8.17142 17.0001 8.57265V12.3504C17.0001 12.7517 16.6748 13.0769 16.2736 13.0769H15.6923V14.3846C15.6923 15.8291 14.5214 17 13.0769 17H2.61538C1.17095 17 0 15.8291 0 14.3846V3.92308V2.61538C0 1.17095 1.17095 0 2.61538 0H10.4615C11.906 0 13.0769 1.17095 13.0769 2.61538V3.92308ZM13.9923 7.84615H13.077C11.6326 7.84615 10.4616 9.0171 10.4616 10.4615C10.4616 11.906 11.6326 13.0769 13.077 13.0769H15.6923V13.0769H13.9923V14.3846C13.9923 14.8902 13.5825 15.3 13.0769 15.3H2.61538C2.10983 15.3 1.7 14.8902 1.7 14.3846V5.62308H13.0769C13.5825 5.62308 13.9923 6.03291 13.9923 6.53846V7.84615ZM15.3001 9.54615H13.077C12.5714 9.54615 12.1616 9.95599 12.1616 10.4615C12.1616 10.9671 12.5714 11.3769 13.077 11.3769H15.3001V9.54615Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.ce871d463428cfd25267d5238c58d1ff.svg";
export { ForwardRef as ReactComponent };